import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthguardGuard implements CanActivate {
  constructor(public router: Router){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    var isLoggedIn = localStorage.getItem('isLoggedIn')
    if(isLoggedIn == 'true'){
      return true;
    }else {
      console.log('Blocked by auth guard')
      this.router.navigate(['/login']);
      return false;
    }
  }
  
}
